import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

export const Styles = StyleSheet.create({
  container: {
    borderRadius: 20,
    overflow: 'hidden',
    backgroundColor: Colors.v2.gray05,
  },
  square: {
    width: 120,
    height: 120,
    borderRadius: 20,
    backgroundColor: Colors.v2.gray05,
  },
  border: {
    borderWidth: 1,
    borderColor: Colors.v2.gray10,
    flexShrink: 1,
  },
  semitransparent: { opacity: 0.5 },
  wrap: { alignSelf: 'flex-start' },
});

export const UnvalidatedStyles = {
  fallbackFileNameText: {
    alignSelf: 'stretch', // full width
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
